import getters from './getters'
import actions from './actions'
import mutations from './mutations'
const state = {
    jumps: [],
    jumpsHistory: [],
    jumpsHistoryCash: [],
    modelDefault: {
        id: null,
        title: '',
        url: null,
        bot_id: null,
        parent_id: 0,
        deleted: 0,
        created_at: null,
        type: 0,
        last_history_id: 0,
        last_updated_time: null,
        all_jumps: 0
    }
}
export default {
    state,
    getters,
    actions,
    mutations
}
